import { render, staticRenderFns } from "./VcaPopover.vue?vue&type=template&id=601379e9&scoped=true"
import script from "./VcaPopover.vue?vue&type=script&lang=js"
export * from "./VcaPopover.vue?vue&type=script&lang=js"
import style0 from "./VcaPopover.vue?vue&type=style&index=0&id=601379e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601379e9",
  null
  
)

export default component.exports